import base from '../dr-base'
import drCaptcha from './dr-captcha.vue'

export default {
  schema: {
    $Type: 'dr-captcha',
    name: 'Captcha',
    group: 'Input widgets',
    icon: 'tooltip-check',
    ...base,
    properties: {
      ...base.properties,
      Value: {
        name: 'vuetifyWidgets.dr-captcha.value',
        type: 'string',
        default: '',
        component: 'dr-value-editor'
      }
    }
  },
  component: drCaptcha
}
